import { PosSessionRepository } from './ports/PosSessionRepository';
import { ShiftRepository } from './ports/ShiftRepository';
import { OrderRepository } from './ports/OrderRepository';
import { TableRepository } from './ports/TableRepository';
import { MenuRepository } from './ports/MenuRepository';
import { BranchRepository } from './ports/BranchRepository';
import { AuditLogRepository } from '../audit/ports/AuditLogRepository';
import { PrinterRepository } from './ports/PrinterRepository';

import { SupabasePosSessionRepository } from '@infrastructure/supabase/SupabasePosSessionRepository';
import { SupabaseShiftRepository } from '@infrastructure/supabase/SupabaseShiftRepository';
import { SupabaseOrderRepository } from '@infrastructure/supabase/SupabaseOrderRepository';
import { SupabaseTableRepository } from '@infrastructure/supabase/SupabaseTableRepository';
import { SupabaseMenuRepository } from '@infrastructure/supabase/SupabaseMenuRepository';
import { SupabaseBranchRepository } from '@infrastructure/supabase/SupabaseBranchRepository';
import { SupabaseAuditLogRepository } from '@infrastructure/supabase/SupabaseAuditLogRepository';
import { SupabasePrinterRepository } from '@infrastructure/supabase/SupabasePrinterRepository';

class PosDomainFactory {
  private posSessionRepo: PosSessionRepository;
  private shiftRepo: ShiftRepository;
  private orderRepo: OrderRepository;
  private tableRepo: TableRepository;
  private menuRepo: MenuRepository;
  private branchRepo: BranchRepository;
  private auditLogRepo: AuditLogRepository;
  private printerRepo: PrinterRepository;

  constructor() {
    this.posSessionRepo = new SupabasePosSessionRepository();
    this.shiftRepo = new SupabaseShiftRepository();
    this.orderRepo = new SupabaseOrderRepository();
    this.tableRepo = new SupabaseTableRepository();
    this.menuRepo = new SupabaseMenuRepository();
    this.branchRepo = new SupabaseBranchRepository();
    this.auditLogRepo = new SupabaseAuditLogRepository();
    this.printerRepo = new SupabasePrinterRepository();
  }

  getRepository() {
    return this.posSessionRepo;
  }

  getShiftRepository() {
    return this.shiftRepo;
  }

  getOrderRepository() {
    return this.orderRepo;
  }

  getTableRepository() {
    return this.tableRepo;
  }

  getMenuRepository() {
    return this.menuRepo;
  }

  getBranchRepository() {
    return this.branchRepo;
  }

  getAuditLogRepository() {
    return this.auditLogRepo;
  }

  getPrinterRepository() {
    return this.printerRepo;
  }
}

export const posDomain = new PosDomainFactory();
